import useMedia from "use-media";

export const MAX_MOBILE_WIDTH = "700px";

export function useIsMobile() {
  return useMedia({ maxWidth: MAX_MOBILE_WIDTH });
}
